import React from 'react'
import AlertSection from "../Alert Section/Alert Section";
import Firstsection from "../Firstsection/Firstsection ";
import Secondsection from "../secondSection/secondsection";
import Thirdsection from "../ThirdSection/thirdsection";
import Fourthsection from "../FourthSection/Fourthsection";
import Fifthsection from "../FifthSection/fifthsection";
import SixthSection from "../SixthSection/SixthSection";


function Store() {
  return (
    <div>
      <AlertSection />
      <Firstsection />
      <Secondsection />
      <Thirdsection />
      <Fourthsection />
      <Fifthsection />
      <SixthSection />
    </div>
  );
}

export default Store